<template>
  <v-container>
    <h2>
      <template v-if="step === 1">
        Have you had a bankruptcy in the last 7 years?
      </template>
      <template v-else>
        Do you have disclosure events which are financial, termination or regulatory?
      </template>
    </h2>

    <div class="option-wrapper column">
      <button
        class="default-btn blue"
        @click="step === 1 ? setRegulatoryIssues(false) : setHasDisclosureEvent(false)">
          <template v-if="step === 1">
            No, I have not had a bankruptcy in the last 7 years
          </template>
          <template v-else>
            No, I don't have disclosure events
          </template>
      </button>

      <button
        class="default-btn red inverse"
        @click="step === 1 ? setRegulatoryIssues(true) : setHasDisclosureEvent(true)">
        <template v-if="step === 1">
          Yes, I have had a bankruptcy in the last 7 years
        </template>
        <template v-else>
          Yes, I have disclosure events
        </template>
      </button>
    </div>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'QuestionnaireIssuesStep',
  data: () => ({
    hasRegulatoryIssues: null,
    hasDisclosureEvents: null,
    step: 1,
  }),
  methods: {
    ...mapActions('questionnaireStore', ['updateMatchData']),
    setRegulatoryIssues (has) {
      this.hasRegulatoryIssues = has
      this.step++
    },
    setHasDisclosureEvent (has) {
      this.hasDisclosureEvents = has
      this.goToNextStep()
    },
    async goToNextStep () {
      await this.updateMatchData({
        hasRegulatoryIssues: this.hasRegulatoryIssues,
        hasDisclosureEvents: this.hasDisclosureEvents,
      })

      this.$emit('finished')
    },
  },
}
</script>

<style lang="scss" scoped>
.container .option-wrapper .default-btn {
    width: 450px;
    max-width: 100%;
}
</style>
